import React from 'react';
import PropTypes from 'prop-types';

export const FieldSkeleton = () => (
  <div className="h-3.5 w-32 bg-gray-200 rounded animate-pulse mt-1" />
);

export const SectionSkeleton = ({ rows = 3, cols = 4 }) => (
  <div className={`grid grid-cols-${cols} gap-x-8 gap-y-5`}>
    {Array.from({ length: rows * cols }).map((_, i) => (
      <div key={i}>
        <div className="h-2.5 w-16 bg-gray-200 rounded animate-pulse mb-1.5" />
        <FieldSkeleton />
      </div>
    ))}
  </div>
);

SectionSkeleton.propTypes = {
  rows: PropTypes.number,
  cols: PropTypes.number,
};

SectionSkeleton.defaultProps = {
  rows: 3,
  cols: 4,
};

export const TableSectionSkeleton = ({ cols = 4, rows = 3 }) => (
  <div className="divide-y divide-gray-50">
    {Array.from({ length: rows }).map((_, i) => (
      <div key={i} className="flex gap-6 px-6 py-3 animate-pulse">
        {Array.from({ length: cols }).map((__, j) => (
          <div key={j} className="h-3 bg-gray-200 rounded flex-1" />
        ))}
      </div>
    ))}
  </div>
);

TableSectionSkeleton.propTypes = {
  cols: PropTypes.number,
  rows: PropTypes.number,
};

TableSectionSkeleton.defaultProps = {
  cols: 4,
  rows: 3,
};